const config = {
    BASE_URL: process.env.REACT_APP_API_BASE_URL || "https://vardaanqa.cleartripcorp.com",
    BENEFIT_ENGINE: {
        BASE: "/benefit-engine/intent-capture",
        CAMPAIGN: {
            BASE: "/campaign"
        },
        RULE: {
            BASE: "/rules"
        },
        UI_CONFIG: {
            BASE: "/resource/UIConfig"
        }
    }
}

export default config;
